<script setup>
import { onMounted } from 'vue';
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/holiday-gifts/products/*', { eager: true });

useHead({});

onMounted(() => {
	let embedScript = document.createElement('script');
	embedScript.setAttribute('src', `https://online.flippingbook.com/EmbedScriptUrl.aspx?m=redir&hid=271887717`);
	document.head.appendChild(embedScript);
});

const products = [
	{
		title: "Fireside Flavors Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitfireside-flavors-gift-set.png"].default
	},
	{
		title: "Cozy Cabin Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitcozy-cabin-gift-set.png"].default
	},
	{
		title: "New Years Tost Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitnew-years-tost-gift-set.png"].default
	},
	{
		title: "Heritage Bundle Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitheritage-bundle-gift-set.png"].default
	},
	{
		title: "Autumn Nights Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitautumn-nights-gift-set.png"].default
	},
	{
		title: "Elite Escape Kit", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitelite-escape-kit.png"].default
	},
	{
		title: "Sun & Sounds Holiday Kit", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitsun--sounds-holiday-kit.png"].default
	},
	{
		title: "All Wrapped Up Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitall-wrapped-up-gift-set.png"].default
	},
	{
		title: "Happy Camper Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykithappy-camper-gift-set.png"].default
	},
	{
		title: "Winter Unwind Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitwinter-unwind-gift-set.png"].default
	},
	{
		title: "The Holiday Escape Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitthe-holiday-escape-gift-set.png"].default
	},
	{
		title: "Scents of Joy", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitscents-of-joy.png"].default
	},
	{
		title: "Holiday Tile Tracker Kit", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitholiday-tile-tracker-kit.png"].default
	},
	{
		title: "Relax Body Care Kit", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitrelax-body-care-kit.png"].default
	},
	{
		title: "Adventure Kit", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitadventure-kit.png"].default
	},
	{
		title: "Sugarfina Sweet Perks Gift Box", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitsugarfina-sweet-perks-gift-box.png"].default
	},
	{
		title: "Chasing Adventure Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitchasing-adventure-gift-set.png"].default
	},
	{
		title: "Carter 3 in 1 Lid Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitcarter-3-in-1-lid-gift-set.png"].default
	},
	{
		title: "Season of Strength Kit", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitseason-of-strength-kit.png"].default
	},
	{
		title: "Wanderer's Writing Gift Set", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitwanderers-writing-gift-set.png"].default
	},
	{
		title: "W&P Porter Eco-Commuter Bundle", 
		src: imagesGlob["../../images/brands/holiday-gifts/products/swaggerproductpagewebsiteholidaykitwp-porter-ecocommuter-bundle.png"].default
	},
];

</script>

<template lang="pug">
.page.page--brand.holiday-gifts
	section.hero
		.hero__bg
		.hero__content
			.image
				img(src='@static/images/brands/holiday-gifts/hero.png' alt='Holiday gift kit in a kraft box with a Fellow matte gray tumbler, chocolate ornament in a clear box with ribbon, festive filler, and a holiday card.')
			.copy
				h1 Holiday Gifting<br/>with Swagger
				p Looking for the perfect holiday gift? You’re in the right place. Explore our curated collection of crowd-pleasing favorites, or let us help you create a custom kit tailored just for your team. From timeless essentials to festive standouts, we make holiday gifting simple, seamless, and unforgettable.

	.page__content
		section.section.section--easy
			.section__content
				h2.alpha We Make it Easy
				.pack
					.item
						img(src='@static/images/brands/holiday-gifts/step1.svg')
					.item
						.step
							span STEP
							span.num 1
						.copy
							h4 Voice Your Vision
							p Share your gifted ideas, desires, and goals with us. Let your creativity flow, and we'll take it from there to transform your vision into a branded masterpiece.
				.pack.alt
					.item
						img(src='@static/images/brands/holiday-gifts/step2.svg')
					.item
						.step
							span STEP
							span.num 2
						.copy
							h4 Select the Perfect Present
							p Choose from our curated collection of gift options or let us take the reins. Whether you're hands-on or prefer us to do the heavy lifting, we've got you covered. 
				.pack
					.item
						img.plane(src='@static/images/brands/holiday-gifts/step3.svg')
					.item
						.step
							span STEP
							span.num 3
						.copy
							h4 Enjoy the Stress-Free Journey
							p Sit back, relax, and watch the magic unfold. From decoration and ordering to seamless shipping, we handle it all. Your unique, personalized gifts will be on their way while you get to enjoy some peace of mind.
				.graphic
					h2.alpha Mark Your Calendar
					table.table.table--ghost
						tbody
							tr
								td
									span Order By:
								td
									span Oct 7
								td
									span Oct 28
								td
									span Nov 25
							tr
								td
								td.dots
									img(src="@static/images/dotted-two.svg")
								td.dots
									img(src="@static/images/dotted-two.svg")
								td.dots
									img(src="@static/images/dotted-two.svg")
							tr
								td
									span Receive By:
								td
									span Nov 15
								td
									span Dec 6
								td
									span Jan 3

		section.section.section--lookbook
			.bg
			.section__content
				.copy
					h2 Need a Little Extra Holiday Spark?
					p Our 2025 Holiday Lookbook is filled with curated gifts designed to spark joy, foster connection, and make every celebration unforgettable. From bold statement pieces to thoughtful finishing touches, Swagger helps you give with style, personality, and just the right amount of holiday magic, creating moments that linger long after the wrapping is gone.
				.lb
					//- TODO - there should be a FlippingBookWrapper component for these (child of LookbookShow)
					a(href='https://lookbooks.giveswagger.com/view//271887717' class="fbo-embed" data-fbo-id="f37d30f2ac" data-fbo-ratio="3:2" data-fbo-lightbox="yes" data-fbo-width="100%" data-fbo-height="auto" data-fbo-version="1" style="max-width: 100%")
							
		section.section.section--form
			.section__content
				h2 Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="holiday-gifts")

		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src")
						.product-card__text
							p {{product.title}}


		section.section.section--foot
			.colorbar
				.bar
				.bar
				.bar
				.bar
				.bar

</template>

<style></style>